// Lead do catálogo do leilão. Antes da compra vem mascarado: CPF parcial, nome
// abreviado e sem telefone/matrícula/CNPJ/nascimento. Depois de comprado (ou
// enquanto está no histórico do cliente) vem completo.
export interface LeilaoLead {
	id: string;
	cpf: string;
	nome: string | null;
	telefone: string | null;
	temWhatsapp: boolean | null;
	status: string;
	bancosElegiveis: string[];
	margemDisponivel: number | null;
	valorLiberado: number | null;
	nroParcelas: number | null;
	matricula: string | null;
	cnpjEmpregador: string | null;
	dataNascimento: string | null;
	dataAdmissao: string | null;
	createdAt: string;
	// Preço deste lead para este cliente e a faixa que o gerou.
	price: number;
	tier: 'TODAY' | 'OLD';
	// true = já liberado pelo histórico do cliente (dado aberto, preço 0).
	owned: boolean;
}

export interface LeilaoPageMeta {
	total: number;
	lastPage: number;
	currentPage: number;
	perPage: number;
	prev: number | null;
	next: number | null;
	capped?: boolean;
}

export interface LeilaoPage {
	data: LeilaoLead[];
	meta: LeilaoPageMeta;
}

export interface LeilaoFilters {
	page?: number;
	limit?: number;
	cpf?: string;
	dateStart?: string;
	dateEnd?: string;
	banks?: string;
	margemMin?: number;
	margemMax?: number;
	admissionMonthsMin?: number;
	admissionMonthsMax?: number;
}

export interface LeilaoPurchase {
	id: string;
	opportunityId: string;
	cpf: string;
	price: number;
	leadDate: string;
	tier: 'TODAY' | 'OLD';
	data: Omit<LeilaoLead, 'price' | 'tier' | 'owned'>;
	createdAt: string;
}

export interface LeilaoPurchaseResult {
	leads: LeilaoLead[];
	// Ids que não existiam mais no catálogo — nada foi cobrado por eles.
	skipped: string[];
	// Ids que vieram de graça por ainda estarem no histórico do cliente.
	free: string[];
	charged: number;
	balance: number;
}

export interface LeilaoConfig {
	priceToday: number;
	priceOld: number;
	// O catálogo é a união das bases dessas companies do Wesend.
	companyIds: string[];
}

// Bancos que o leilão do Wesend classifica como elegíveis.
export const LEILAO_BANKS = ['C6', 'FACTA', 'MERCANTIL', 'V8', 'UY3', 'NOVO_SAQUE', 'RN3'];
